/*
 * ===============================================================================================================
 *                                Copyright 2022, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { SET_USER_FORMDATA, RESET_USER_FORMDATA } from "./../types";
import { SAVE_USER_FORM_VALUES_INITIAL_STATE } from "./constants";

export const saveUserReducerInitialState = {
  formValues: SAVE_USER_FORM_VALUES_INITIAL_STATE
};

export const saveUserReducer = (state = saveUserReducerInitialState, action: any) => {
  switch (action.type) {
    case SET_USER_FORMDATA:
      return {
        ...state,
        formValues: { ...state.formValues, ...action.data },
      }
    case RESET_USER_FORMDATA:
      return saveUserReducerInitialState;
    default:
      return state;
  }
};
